/**
 * 确认弹窗组件
 * 用于需要二次确认的危险操作（如删除）
 */

import React from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean; // 是否是危险操作（确认按钮显示红色）
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget && !loading) onCancel();
      }}
    >
      <div className="bg-white rounded-2xl shadow-xl w-[340px] md:w-[400px] p-6 relative">
        {/* 标题 */}
        <div className="text-center mb-4">
          <h2 className="text-xl font-semibold text-[#333333]">{title}</h2>
        </div>

        {/* 内容 */}
        <div className="text-center mb-6">
          <p className="text-[14px] text-[#666666]">{message}</p>
        </div>

        {/* 按钮区域 */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 py-3 rounded-full border border-[#EBEBEB] text-[14px] font-medium text-[#333333] hover:bg-[#F5F5F7] transition-colors disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 py-3 rounded-full text-[14px] font-medium transition-colors disabled:opacity-50 flex items-center justify-center ${
              danger
                ? 'bg-[#FF2442] text-white hover:bg-[#E02040]'
                : 'bg-[#333333] text-white hover:bg-[#444444]'
            }`}
          >
            {loading ? (
              <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full" />
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>

      {/* ESC 关闭 */}
      {isOpen && !loading && (
        <style>{`
          /* 键盘监听通过 useEffect 处理 */
        `}</style>
      )}
    </div>
  );
};

export default ConfirmModal;